<div class="container">
  <div class="header">
    <div class="row">
      <h2>New User</h2>
      <button mat-icon-button aria-label="close dialog" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <p class="description">
      Enter the email address for the new user and assign the appropriate roles
      and access.
    </p>
  </div>
  <div class="form-section">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <!-- Email Field -->
      <div class="form-group">
        <label class="form-label" for="email">Email</label>
        <mat-select
          id="email"
          formControlName="email"
          placeholder="Select a user"
        >
          <mat-option *ngFor="let user of userData" [value]="user.email">
            {{ user.email }}
          </mat-option>
        </mat-select>
        <div
          class="error"
          *ngIf="
            userForm.get('email')?.touched &&
            userForm.get('email')?.hasError('required')
          "
        >
          Email is required
        </div>
      </div>

      <!-- PRID Field -->
      <div class="form-group">
        <label class="form-label" for="prid">PRID</label>
        <input
          id="prid"
          type="text"
          formControlName="prid"
          placeholder="KABC123"
        />
        <div
          class="error"
          *ngIf="
            userForm.get('prid')?.touched &&
            userForm.get('prid')?.hasError('required')
          "
        >
          PRID is required
        </div>
      </div>

      <!-- Name Field -->
      <div class="form-group">
        <label class="form-label" for="name">Name</label>
        <input
          id="name"
          type="text"
          formControlName="name"
          placeholder="Example"
        />
        <div
          class="error"
          *ngIf="
            userForm.get('name')?.touched &&
            userForm.get('name')?.hasError('required')
          "
        >
          Name is required
        </div>
      </div>

      <!-- Type of User Dropdown -->
      <div class="form-group">
        <label class="form-label" for="typeOfUser">Type of User</label>
        <select id="typeOfUser" formControlName="typeOfUser">
          <option value="" disabled selected hidden>Select a user type</option>
          <option *ngFor="let role of userRoles" [value]="role.role">
            {{ role.label }}
          </option>
        </select>
        <div
          class="error"
          *ngIf="
            userForm.get('typeOfUser')?.touched &&
            userForm.get('typeOfUser')?.hasError('required')
          "
        >
          Type of User is required
        </div>
      </div>

      <!-- Region Radio Buttons -->
      <div class="form-group" [class.hidden]="hideRegionData">
        <label class="form-label">Region</label>

        <div class="radio-group">
          <span *ngFor="let region of regions">
            <input
              formControlName="region"
              type="radio"
              id="by-region-{{ region.id }}"
              [value]="region.id"
            />
            <label for="by-region-{{ region.id }}">{{ region.id }}</label>
          </span>
        </div>
        <div
          class="error"
          *ngIf="
            userForm.get('region')?.touched &&
            userForm.get('region')?.hasError('required')
          "
        >
          Region is required
        </div>
      </div>

      <!-- Market Dropdown -->
      <div class="form-group" [class.hidden]="hideRegionData">
        <label class="form-label" for="market">Market</label>
        <mat-select
          formControlName="market"
          multiple
          id="market"
          disableRipple
          placeholder="Select a market"
          #marketSelect
        >
          <mat-select-trigger>
            {{ getMarketDisplay(marketSelect.value) }}
          </mat-select-trigger>
          <mat-option value="_ALL">All</mat-option>
          <mat-option *ngFor="let market of markets" [value]="market.name">
            {{ market.name }}
          </mat-option>
        </mat-select>

        <div
          class="error"
          *ngIf="
            userForm.get('market')?.touched &&
            userForm.get('market')?.hasError('required')
          "
        >
          Market is required
        </div>
      </div>

      <!-- Therapeutic Area Checkboxes -->
      <div class="form-group" [class.hidden]="hideRegionData">
        <label class="form-label">Therapeutic Area</label>

        <form class="checkbox-group" [formGroup]="therapeuticAreaForm">
          <span *ngFor="let area of therapeuticAreas">
            <input
              type="checkbox"
              id="ta-checkbox-{{ area }}"
              [formControl]="getTherapeuticAreaFormControl(area)"
            />
            <label for="ta-checkbox-{{ area }}">{{ area }}</label>
          </span>
        </form>
        <div
          class="error"
          *ngIf="
            userForm.get('therapeuticArea')?.touched &&
            userForm.get('therapeuticArea')?.hasError('required')
          "
        >
          At least one therapeutic area is required
        </div>
      </div>

      <!-- Submit Button -->
      <div class="actions">
        <div class="submitting-indicator" *ngIf="isSubmitting">
          <app-spinner
            [display]="true"
            [class]="'spinner-container direction-row'"
            [diameter]="24"
          ></app-spinner>
        </div>
        <button class="secondary" type="button" (click)="closeDialog()">
          Cancel
        </button>
        <button class="fill" [disabled]="!userForm.valid || isSubmitting">
          Apply
        </button>
      </div>
    </form>
  </div>
</div>
